<template>
    <div class="header_title">
        <span class="icon_tile">
            <h2 title="基于大数据能力和场景化的营销平台">
                {{ msg }}
            </h2>
            <h5>广告生态服务平台</h5>
            <img class="images" src="../assets/dj.png" alt="" />
        </span>
        <span class="menu_title">
            <h4><a href="#content" >首页</a></h4>
            <h4><a href="#ad-type" >广告形式</a></h4>
            <h4><a href="http://ssp.ixiway.com/#/login" target="_blank">媒体入口</a></h4>
            <h4><a href="#link-us" >联系我们</a></h4>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'LaHeader',
        props: {
            msg: String
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header_title {
        position: fixed;
        width: 100%;
        z-index: 99;
        color: white;
        top: 0px;
        height: 100px;
        background-color: #384047;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-items: center;
        text-align: center;
        horiz-align: center;
    }

    .icon_tile{
        position: relative;
        margin-left: 15%;
        width: 30%;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-items: center;
        text-align: center;
        font-size: 20px;
        margin-top: 3px;
    }
    
    .images{
        position: absolute;
        top: -11px;
        left: -130px;
        width: 130px;
        height: 110px;
    }

    .menu_title h4 a {
        color: #ffffff;
        text-decoration: none;
        font-size: 18px;
    }

    .menu_title h4 a:hover {
        color: #3399ff;
    }

    .menu_title h4 a:active {
        color: #3399ff;
    }

    .icon_tile h5 {
        padding-top: 10px;
        margin-left: 1%;
    }

    .menu_title {
        margin-left: 10%;
        width: 60%;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-items: center;
        text-align: center;
        line-height: 45px;
    }

    .menu_title h4 {
        padding-top: 5px;
        margin-left: 3%;
        margin-right: 3%;
    }

</style>
